export default function WorkspaceSelectionModeBar({ count, missingCount = 0, onExit }) {
  return (
    <div className="workspace-selection-mode-bar" role="status">
      <div>
        <strong>Рабочая подборка</strong>
        <span>Найдено: {count}</span>
        {missingCount > 0 && <span className="workspace-selection-mode-bar__missing">Не найдено: {missingCount}</span>}
      </div>
      <button type="button" onClick={onExit}>Выйти из режима</button>
    </div>
  );
}
